import { UserSimpleModel } from '@repositories/userRepository/models/UserSimpleModel';
import type { UserGroupMember } from '../userGroups.types';

export class UserGroupMemberModel {
  private readonly _dto: UserGroupMember;

  constructor(dto?: UserGroupMember) {
    this._dto = dto ?? { user: {} as UserGroupMember['user'] };
  }

  get originDTO(): UserGroupMember {
    return this._dto;
  }

  get user(): UserSimpleModel {
    return new UserSimpleModel(this._dto.user);
  }
}
